export const SHOPIFY_PROVISIONER_ID = "shopifyP-0089-4993-9864-a09b4502503e";
